import React from 'react';
import cx from 'classnames';

/**
 * ContentWide: wide content container, max-width 1296px, responsive padding
 * NO usa Container base para evitar el override de max-width/padding
 */

type Alignment = 'left' | 'center' | 'right';

interface ContentWideProps {
  /** Child elements to render inside the container */
  children?: React.ReactNode;
  /** Additional CSS classes */
  className?: string;
  /** HTML element type to render as */
  as?: React.ElementType;
  /** ARIA label for accessibility */
  ariaLabel?: string;
  /** Additional HTML attributes */
  [key: string]: any;
  /** Horizontal alignment of the content in desktop*/
  alignment?: Alignment;
  /**Horizontal alignment of the content in mobile */
  mobileAlignment?: Alignment;
  /** Top padding */
  paddingTop?: string;
  /** Bottom padding */
  paddingBottom?: string;
  /** Gap */
  gap?: string;
}

const ContentWide: React.FC<ContentWideProps> = ({
  children,
  className = '',
  ariaLabel = 'Content Wide',
  as: Component = 'div',
  alignment = 'left',
  mobileAlignment = 'left',
  paddingTop,
  paddingBottom,
  gap,
  ...rest
}) => {

  const containerStyles: React.CSSProperties = {
    display: "flex",
    paddingTop,
    paddingBottom,
    gap,
    ...(rest.style || {}),
  };

  return (
    <Component
      className={cx(
        'content-wide',
        `content-desktop-${alignment}`,
        `content-mobile-${mobileAlignment}`,
        className
      )}
      style={containerStyles}
      aria-label={ariaLabel}
      role="section"
      {...rest}
    >
      {children}
    </Component>
  );
};

export default ContentWide;
